import data from "../../../../../src/TabNav/TabNav.docs.json";
import * as React from 'react';
export default {
  data,
  React
};